export const sensorBrands = [
    'Escorts TD-BLE', 'Mielta Phantom BT', 'Roadmatics Basic'
];

export const tankContent = [
    'Diesel',
    'Petrol',
    'Engine Oil',
    'Kerosene',

];

export const sensorKeys =
    ['setupId', 'assetId', 'sensorIndex',
        'sensorSerial', 'sensorParam', 'sensorMac', 'sensorBrand',
        'manufacturerSerial'];

export const tankKeys = ['assetId', 'name', 'tankIndex',
    'setupId', 'noOfSensors', 'content', 'volume',
    'expectedMileage', 'expectedHourly', 'minFillThreshold',
    'minTheftThreshold'];

export const aggregationMethodOptions = [
    { label: 'Addition', value: 'add' },
    { label: 'Average', value: 'avg' },

];

export const sensorParamOptions = [
    'ble1_fuel_raw1', 'ble1_fuel_raw2', 'ble1_fuel_raw3', 'ble1_fuel_raw4',
    'ain2', 'ain1', 'fuel_level',
];